<script setup>
import { ref, onMounted, computed } from "vue"
import { useSettingsStore } from '../stores/settings'
import { useUsersStore } from "../stores/users";

const settingsID = 'settings-calendar'

const store = useSettingsStore()
const userStore = useUsersStore()

import { useForm } from 'vee-validate';

import * as yup from 'yup';

const { errors, defineField, handleSubmit } = useForm({
  validationSchema: yup.object({
    name: yup.string().max(30).min(1).required(),
    url: yup.string().url().required(),
  }),
});

// const loadTheme = () => store.loadTheme()

// const calendars = computed({
//   get() {
//     return store.calendars
//   },
//   set(newValue) {
//     store.setTheme(newValue)
//   }
// })

const addCalendar = async () => {
  try {
    await store.createCalendar({
    name: "New Calendar",
      url: "",
      color: "Blue",
      enabled: false,
      owner: userStore.currentUser.id
  })
  // change edit mode of last item
  const mostRecentIndex = store.calendars.length-1
  store.calendars[mostRecentIndex].editMode = true
  } catch (error) {
    // show the error to the user
    throw error
  }
  
  // store.calendars.push(
  //   {
  //     name: "Main",
  //     url: "",
  //     color: "Blue",
  //     enabled: true
  //   }
  // )
}

const saveCalendar = (calendar, index) => {
  // Fix the url if needed.
  
  if (calendar.url.substring(0, 6) === 'webcal') {
    store.calendars[index].url = calendar.url.replace('webcal', 'https')
  }

  //update the database
  store.updateCalendar(store.calendars[index].id, store.calendars[index])

  // Hide the editor
  store.calendars[index].editMode = false
}

const deleteCalendar = (calendar, index) => {
  // const foundCal = store.calendars.findIndex(each => each.url === calendar.url)
  // if (foundCal !== -1) {
  //   throw new Error("Unable to delete Calendar " + calendar.name + ". Cannot be found.")
  // }
  store.deleteCalendar(store.calendars[index].id)
  // store.calendars.splice(index, 1)
}

const getID = (theme) => `${settingsID}-${theme}`

const colorOptions = [
  {
    color: "Blue"
  },
  {
    color: "Green"
  },
  {
    color: "Magenta"
  },
  {
    color: "Purple"
  },
  {
    color: "Orange"
  },
  {
    color: "SkyBlue"
  },
]

onMounted(async () => {
  await store.initializeCalendars()
})
</script>

<template>
  <div class="flex flex-wrap">
    <!-- <div class="cell medium-3 small-8">
      <label class="middle">Calendars</label>
    </div> -->
    <div class="w-full">
      <h5 class="text-xl mt-0 mb-2">Calendars</h5>
      
        <template v-for="(each, index) in store.calendars" :key="index">
          <div @dblclick="each.editMode=true" class="callout rounded-md" :class="each.color">
          <div v-if="!each.editMode">
            <h3 class="text-lg mt-0 mb-2 lg:text-3xl">{{ each.name }}</h3>
            <p class="text-truncate mb-4 leading-6 max-w-full overflow-hidden text-ellipsis whitespace-nowrap">url: {{ each.url }}</p>
          <div class="button-group">
            <button type="button" class="btn btn-secondary" @click="each.editMode = true">Edit</button>
          </div>
          </div>
          
          <div v-else>
            <label class="block m-0 text-sm leading-relaxed">
            Name: 
            <input type="text" class="input" v-model="each.name">
            </label>
            <label class="block m-0 text-sm leading-relaxed">
            URL: 
            <input
              
              v-model="each.url"
              class="input"
              type="url"
              name="settings-theme"
            />
          </label>
          <label class="block m-0 text-sm leading-relaxed">
            Color: 
            <!-- <input type="color" :id="getID(each.name) + '-color'" v-model="each.color"> -->
            <select v-model="each.color" class="input">
              <option v-for="(option, index) in colorOptions" :key="index" :value="option.color">{{ option.color }}</option>
            </select>
            </label>
            <label class="block m-0 text-sm leading-relaxed">
            Enabled: 
            <div class="text-white relative mb-4 outline-0 font-bold text-sm h-8 select-none rounded-full">
              <input class="peer absolute mb-0 opacity-0 " v-model="each.enabled" id="exampleSwitch" type="checkbox" name="exampleSwitch">
              <label class="rounded-md peer-checked:bg-primary-100 peer-checked:dark:bg-sky-800 peer-checked:after:left-9 bg-secondary-100 relative inline-block w-16 h-8 transition-all !m-0 after:absolute after:top-1 after:left-1 after:block after:w-6 after:h-6 after:transform-gpu after:translate-x-0 after:translate-y-0 after:bg-white after:dark:bg-neutral-800 after:transition-all after:content-[''] after:rounded-md" for="exampleSwitch">
                <span class="show-for-sr overflow-hidden absolute h-[1px] w-[1px] p-0 whitespace-nowrap border-0">Enable Calendar</span>
              </label>
            </div>
          </label>
          <div class="">
            <button type="button" class="btn btn-secondary mr-1" @click="saveCalendar(each, index)">Done</button><button type="button" class="btn btn-alert" @click="deleteCalendar(each, index)">Delete</button>
          </div>
          </div>
        </div>
        </template>
        
      
      <button class="btn btn-primary" type="button" @click="addCalendar">Add Calendar</button>
    </div>
    <div class="flex-1"></div>
  </div>
</template>
